import { Flex, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProposalGoalPreviewGrowth from "../../../ProposalGoalPreviewGrowth";
import ProposalGoalPreviewIncome from "../../../ProposalGoalPreviewIncome";

import StyledContainer from "./style";

import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const SectionReviewProposal = ({
  handleClose,
  handleDownloadProposal,
  productLiveAssessment,
  productsLiveSimulation,
  proposalId,
  proposalData,
  selectedProductData,
}) => {
  const isGrowthTypeProposal = proposalData?.investmentObjective === "growth";

  const Footer = () => (
    <Flex justify="space-between">
      <Button
        icon={<FontAwesomeIcon icon={faArrowLeft} />}
        onClick={handleClose}
        shape="round"
      >
        Edit
      </Button>
      <Button
        onClick={() => handleDownloadProposal(proposalId)}
        shape="round"
        type="primary"
      >
        Save Proposal
      </Button>
    </Flex>
  );

  return (
    <StyledContainer>
      <header>Review Proposal</header>

      {isGrowthTypeProposal ? (
        <ProposalGoalPreviewGrowth
          calculatedSimulation={
            productsLiveSimulation && productsLiveSimulation[0]
          }
          Footer={Footer}
          handleDownloadProposal={() => handleDownloadProposal(proposalId)}
          proposalData={proposalData}
          productData={selectedProductData}
        />
      ) : (
        <ProposalGoalPreviewIncome
          Footer={Footer}
          handleDownloadProposal={() => handleDownloadProposal(proposalId)}
          productLiveAssessment={productLiveAssessment}
          productsLiveSimulation={productsLiveSimulation}
          proposalData={proposalData}
          productData={selectedProductData}
        />
      )}
    </StyledContainer>
  );
};

export default SectionReviewProposal;
